import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Services.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import RookTech from "../../images/rook-no-bg.png";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  FaAndroid,
  FaApple,
  FaExternalLinkAlt,
  FaSearchPlus,
} from "react-icons/fa";
import LangoWebImg from "../../images/LangoDawgWeb/LangoDawgWeb.png";
import ByteNibbleWeb from "../../images/LangoDawgWeb/ByteNibbleWeb.png";
import PixelPaddleWeb from "../../images/LangoDawgWeb/PixelPaddleWeb.png";
import QuizWeb from "../../images/LangoDawgWeb/QuizWeb.png";
import LangoMobileImg from "../../images/LangoDawgMobile/LangoDawgMobile.jpg";
import ByteNibbleMobile from "../../images/LangoDawgMobile/ByteNibbleMobile.jpg";
import PixelPaddleMobile from "../../images/LangoDawgMobile/PixelPaddleMobile.jpg";
import QuizMobile from "../../images/LangoDawgMobile/QuizMobile.jpg";

const Services = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [currentSlides, setCurrentSlides] = useState([]);

  const webSlides = [
    { src: LangoWebImg },
    { src: ByteNibbleWeb },
    { src: PixelPaddleWeb },
    { src: QuizWeb },
  ];

  const mobileSlides = [
    { src: LangoMobileImg },
    { src: ByteNibbleMobile },
    { src: PixelPaddleMobile },
    { src: QuizMobile },
  ];

  const handleOpenGallery = (slides) => {
    setCurrentSlides(slides);
    setOpen(true);
  };

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.servicesMain}>
        <img
          className={styles.towerBackground}
          src={RookTech}
          alt="Rook Tech Background"
        />

        <section className={styles.containerServices}>
          <header className={styles.servicesHeader}>
            <h2 className={styles.title}>{t("services.title")}</h2>
            <p className={styles.subtitle}>{t("services.subtitle")}</p>
          </header>

          <div className={styles.projectsList}>
            {/* PROJECT 1: LANGODAWG WEB */}
            <div className={styles.projectSection}>
              <div className={styles.projectImageContent}>
                <div
                  className={styles.clickableImageWrapper}
                  onClick={() => handleOpenGallery(webSlides)}
                >
                  <div className={styles.browserMockup}>
                    <img
                      src={LangoWebImg}
                      alt="LangoDawg Web"
                      className={styles.projectImg}
                    />
                  </div>
                  <div className={styles.imageOverlay}>
                    <FaSearchPlus size={40} color="#fff" />
                  </div>
                </div>
              </div>

              <div className={styles.projectTextContent}>
                <span className={styles.projectTag}>
                  {t("services.webPlatformTag")}
                </span>
                <h3>{t("services.langoDawgWebTitle")}</h3>
                <p>{t("services.langoDawgWebDesc")}</p>

                <a
                  href="https://langodawg.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.projectBtn}
                >
                  {t("services.visitWebsite")}{" "}
                  <FaExternalLinkAlt
                    style={{ fontSize: "0.8em", marginLeft: "8px" }}
                  />
                </a>
              </div>
            </div>

            {/* PROJECT 2: LANGODAWG MOBILE */}
            <div className={`${styles.projectSection} ${styles.reverse}`}>
              <div className={styles.projectImageContent}>
                <div
                  className={styles.clickableImageWrapper}
                  onClick={() => handleOpenGallery(mobileSlides)}
                >
                  <div className={styles.phoneMockup}>
                    <img
                      src={LangoMobileImg}
                      alt="LangoDawg Mobile"
                      className={styles.projectImg}
                    />
                  </div>
                  <div className={styles.imageOverlay}>
                    <FaSearchPlus size={40} color="#fff" />
                  </div>
                </div>
              </div>

              <div className={styles.projectTextContent}>
                <span className={styles.projectTag}>
                  {t("services.mobileAppTag")}
                </span>
                <h3>{t("services.langoDawgMobileTitle")}</h3>
                <p>{t("services.langoDawgMobileDesc")}</p>

                <div className={styles.buttonGroup}>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.projectBtn}
                  >
                    <FaAndroid
                      style={{ fontSize: "1.2em", marginRight: "8px" }}
                    />{" "}
                    {t("services.downloadAndroid")}
                  </a>

                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.projectBtn}
                  >
                    <FaApple
                      style={{ fontSize: "1.2em", marginRight: "8px" }}
                    />{" "}
                    {t("services.downloadIOS")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={currentSlides}
        carousel={{ finite: true }}
        controller={{ closeOnBackdropClick: true }}
        styles={{ container: { backgroundColor: "rgba(0, 0, 0, 0.9)" } }}
      />
    </div>
  );
};

export default Services;
